import { render } from "./PdpProductWarehouses.vue?vue&type=template&id=eca6b316"
import script from "./PdpProductWarehouses.vue?vue&type=script&lang=js"
export * from "./PdpProductWarehouses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__